export default __webpack_public_path__ + "8700d003fcf6bf3196c494598267685c.png";